import { Heading, Link, Text } from '@chakra-ui/react';
import type { MouseEvent } from 'react';

import { appUrl } from '@/api/navigation';
import { VStack } from '@/components';

export const NotAllowed = () => {
  const handleReload = (event: MouseEvent) => {
    event.preventDefault();
    window.location.replace(appUrl('/'));
  };

  return (
    <VStack className="NotAllowed" padding={4}>
      <Heading>Not Allowed</Heading>

      <Text>The API returned 403 Forbidden for a Request.</Text>

      <Link href={appUrl('/')} onClick={handleReload}>
        Reload
      </Link>
    </VStack>
  );
};
